import React, { useEffect, useState, useMemo } from "react";
import FormStrip from "../../components/FormStrip";
import { useTranslation } from "react-i18next";
import { MainWrapper } from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader } from "@egovernments/digit-ui-react-components";
import { useHistory, useLocation } from "react-router-dom";
import { Sidebarlabels } from "../../components/data";
import SubStep1 from "./Step1/SubStep1";
import getEDCRData from "./getGroupHousingData";
import useDepartmentSelector from "../../../TCPForms/hooks/useDepartmentSelector";
import getMapSubmissionData from "../map-submission/getMapSubmissionData";
import { ScrutinyUnderProcess } from "../../reusableComponents/ScrutinyLoader";
import { useSelector } from "react-redux";

const GroupHousingPortal = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  console.log("insideGroupHousePortal", id, useParams());

  const history = useHistory();
  const location = useLocation();
  const [, applicationFlow] = useDepartmentSelector();
  const [selectedSubTab, setSelectedSubTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [disable, setDisable] = useState(false);
  const [proposedSite, setProposedSite] = useState(null);
  const { applicationData: edcrData, isAppDataLoading: edcrAppDataLoading } = getEDCRData(id);
  const { applicationData, isAppDataLoading } = getMapSubmissionData(t, id);
  const { info: userInfo } = Digit.UserService.getUser();
  const Modal = useModal();
  const isSelfCert =
    proposedSite === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    proposedSite === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const [edcrParams, setEdcrParams, clearEdcrParams] = Digit.Hooks.useSessionStorage("EDCR_CREATE", edcrData);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_MAP_SUBMISSION", applicationData);
  const documents = useSelector((state) => state.formMTDoc?.documents);
  const {
    data: { LandUseMasterData: { Authorities: schemeTypeData } = {} } = {},
    isLoading: schemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "LandUseMasterData", ["Authorities"]);
  const {
    data: { PrimaryUseMasterData: { ProposedActivity: nonSchemeTypeData } = {} } = {},
    isLoading: nonSchemeTypeDataLoading,
  } = Digit.Hooks.obps.useMDMS(tenantId, "PrimaryUseMasterData", ["ProposedActivity"]);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    setDisable(true);
    const file = formData?.file;
    if (formData) {
      const data = { ...edcrParams, ...formData };
      const userRolesArray = userInfo?.roles.filter((user) => user.code !== "CITIZEN");
      console.log("formDatafromhandlesubtabchange", formData);

      let edcrRequest = {
        transactionNumber: "",
        edcrNumber: "",
        rolesCode: userRolesArray?.[0]?.code || null,
        planFile: null,
        tenantId: "",
        RequestInfo: {
          apiId: "",
          ver: "",
          ts: "",
          action: "",
          did: "",
          authToken: "",
          key: "",
          msgId: "",
          correlationId: "",
          userInfo: userInfo,
        },
      };
      edcrRequest = { ...edcrRequest, ...data };
      let bodyFormData = new FormData();
      bodyFormData.append("planFile", file);
      bodyFormData.append("edcrRequest", JSON.stringify(edcrRequest));
      if (activeTab === 0 && selectedSubTab === 0 && bodyFormData && file) {
        Digit.EDCRService.create({ data: bodyFormData }, tenantId)
          .then((result) => {
            if (result?.data?.edcrDetail) {
              setDisable(false);
              setEdcrParams(result?.data?.edcrDetail);
              history.replace(
                `/digit-ui/citizen/obps/edcrscrutiny/apply/acknowledgement`, ///${result?.data?.edcrDetail?.[0]?.edcrNumber}
                { data: result?.data?.edcrDetail }
              );
            }
          })
          .catch((e) => {
            //setParams({ data: e?.response?.data?.errorCode ? e?.response?.data?.errorCode : "BPA_INTERNAL_SERVER_ERROR", type: "ERROR" });
            setDisable(false);
            Modal("EDCR Error", "Something went wrong!!", "error");
          });
      }
    }
  };

  const handleTabChange = (nextTab, formData = null) => {
    const finalDocuments = formData?.documents?.length > 0 ? formData.documents : documents;

    if (nextTab === 1 && formData) {
      const data = { ...params, ...formData, documents: finalDocuments };
      Digit.OBPSService.create({ BPA: data }, tenantId)
        .then((res) => {
          if (res?.BPA?.length > 0) {
            Modal("Application Created", `Application Created Successfully!`, "success");
            // ["Revalidation/Time Extension"].includes(data?.natureOfConstruction)
            //   ? history.replace(
            //       `/digit-ui/citizen/obps/services/mapRevalidation`, ///${result?.data?.edcrDetail?.[0]?.edcrNumber}
            //       { data: res?.BPA?.[0] }
            //     )
            //   :
            history.replace(
              `/digit-ui/citizen/obps/services/mapSubmissionPortal`, ///${result?.data?.edcrDetail?.[0]?.edcrNumber}
              { data: res?.BPA?.[0] }
            );
          }
        })
        .catch((e) => {
          Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
        });
    }
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading]);

  useEffect(() => {
    if (id && edcrData) {
      setEdcrParams(edcrData);
      if (edcrData?.documents?.length > 0) {
        initFormMTDocs(edcrData.documents);
      }
    }
  }, [id, edcrAppDataLoading]);

  // Memoize formData to prevent unnecessary re-renders of SubStep1

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={isSelfCert ? params : edcrParams}
              handleSubTabChange={handleSubTabChange}
              userInfo={userInfo}
              handleTabChange={handleTabChange}
              setProposedSite={setProposedSite}
              schemeTypeData={schemeTypeData}
              nonSchemeTypeData={nonSchemeTypeData}
              id={id}
            />
          );
        default:
          return null;
      }
    }
  };

  if (isAppDataLoading || edcrAppDataLoading || (id && !applicationData && !edcrData)) {
    return <Loader />;
  }
  if (disable) {
    return <ScrutinyUnderProcess />;
  }
  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <FormStrip formName={"Common  Application Form"} />
      {activeTab === 0 && renderContent()}
    </MainWrapper>
  );
};

export default GroupHousingPortal;
